

import './styles/InternalError.css'

const InternalError=()=>{
   
   
    return (
        <div className='cont-internalError'>
            <div className='body-internalErro'>
                <div className='cont-img-internalErro'>
                <img src="InternalError.png" className="img-InternalError" alt="Logo" />
                </div>
                <div className='cont-txt-internalErro'>
                    <div className='cont-txt-top-internalErro'>
                        !Error!
                    </div>
                    <div className='cont-txt-bot-internalErro'>
                        Se produjo un error interno, favor de reportarlo con el equipo de cassia
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InternalError